document.addEventListener('DOMContentLoaded', () => {
  sessionStorage.removeItem('notificationBarClosed');

  const notificationBar = document.getElementById('notification-bar-slider');
  const messages = notificationBar ? notificationBar.querySelectorAll('.notification-bar__message') : [];

  if (!notificationBar || messages.length === 0) {
    if (notificationBar) notificationBar.style.display = 'none';
    return;
  }

  let currentIndex = 0;
  let intervalId = null;
  const slideInterval = 5000;
  let isPaused = true;
  let isHovering = false;

  let activePauseButton = null;
  let activeCloseButton = null;
  let activePrevButtons = [];
  let activeNextButtons = [];

  const controller = {
    updateActiveControls() {
      if (messages.length === 0 || currentIndex < 0 || currentIndex >= messages.length) return;
      const currentMessage = messages[currentIndex];
      activePauseButton = currentMessage.querySelector('.js-notification-pause');
      activeCloseButton = currentMessage.querySelector('.js-notification-close');
      activePrevButtons = [currentMessage.querySelector('.notification-bar__prev')];
      activeNextButtons = [currentMessage.querySelector('.notification-bar__next')];

      this.attachControlListeners();
    },

    attachControlListeners() {
      if (activePauseButton) {
        activePauseButton.replaceWith(activePauseButton.cloneNode(true));
        activePauseButton = messages[currentIndex].querySelector('.js-notification-pause');
        activePauseButton.addEventListener('click', () => this.togglePause());
      }
      if (activeCloseButton) {
        activeCloseButton.replaceWith(activeCloseButton.cloneNode(true));
        activeCloseButton = messages[currentIndex].querySelector('.js-notification-close');
        activeCloseButton.addEventListener('click', () => this.closeNotifications());
      }
      activePrevButtons.forEach(button => {
        if (button) {
          button.replaceWith(button.cloneNode(true));
          const currentPrevButton = messages[currentIndex].querySelector('.notification-bar__prev');
          currentPrevButton.addEventListener('click', () => this.prevNotification());
        }
      });
      activeNextButtons.forEach(button => {
        if (button) {
          button.replaceWith(button.cloneNode(true));
          const currentNextButton = messages[currentIndex].querySelector('.notification-bar__next');
          currentNextButton.addEventListener('click', () => this.nextNotification(true));
        }
      });
    },

    updatePauseButtonState() {
      if (activePauseButton) {
        if (isPaused) {
          activePauseButton.classList.add('paused');
          activePauseButton.setAttribute('aria-label', 'Resume automatic sliding');
          const pauseText = activePauseButton.querySelector('.pause-text');
          if (pauseText) pauseText.style.display = 'none';
          const playText = activePauseButton.querySelector('.play-text');
          if (playText) playText.style.display = 'flex';
        } else {
          activePauseButton.classList.remove('paused');
          activePauseButton.setAttribute('aria-label', 'Pause automatic sliding');
          const pauseText = activePauseButton.querySelector('.pause-text');
          if (pauseText) pauseText.style.display = 'flex';
          const playText = activePauseButton.querySelector('.play-text');
          if (playText) playText.style.display = 'none';
        }
      }
    },

    showNotification(index) {
      messages.forEach((msg, i) => {
        const displayStyle = i === index ? 'flex' : 'none';
        msg.setAttribute('style', `display: ${displayStyle}`);
      });
      currentIndex = index;
      this.updateActiveControls();
      this.updatePauseButtonState();
    },

    stopAutoSlide() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    },

    startAutoSlide() {
      this.stopAutoSlide();
      if (!isPaused && !isHovering && messages.length > 1) {
        intervalId = setInterval(() => {
          this.nextNotification(false);
        }, slideInterval);
      }
    },

    nextNotification(isManual = true) {
      currentIndex = (currentIndex + 1) % messages.length;
      this.showNotification(currentIndex);
      if (isManual || !isPaused) {
        this.startAutoSlide();
      }
    },

    prevNotification() {
      currentIndex = (currentIndex - 1 + messages.length) % messages.length;
      this.showNotification(currentIndex);
      if (!isPaused) {
        this.startAutoSlide();
      }
    },

    closeNotifications() {
      this.stopAutoSlide();
      notificationBar.style.display = 'none';
      sessionStorage.setItem('notificationBarClosed', 'true');
    },

    togglePause() {
      isPaused = !isPaused;
      if (isPaused) {
        this.stopAutoSlide();
        this.updatePauseButtonState();
      } else {
        this.startAutoSlide();
        this.updatePauseButtonState();
      }
    },

    init() {
      if (messages.length > 0) {
        this.updateActiveControls();
      }

      notificationBar.addEventListener('mouseenter', () => {
        isHovering = true;
        if (!isPaused) {
          this.stopAutoSlide();
        }
      });

      notificationBar.addEventListener('mouseleave', () => {
        isHovering = false;
        if (!isPaused) {
          this.startAutoSlide();
        }
      });

      // Initialize
      if (sessionStorage.getItem('notificationBarClosed') === 'true') {
        notificationBar.style.display = 'none';
      } else {
        this.showNotification(currentIndex);
        this.updatePauseButtonState();
        this.startAutoSlide();
        notificationBar.style.display = 'flex';
      }
    },
  };

  controller.init();
});
